export class MiscFileCategory {
    id: number;
    title: string;

    constructor(data: any) {
        this.id = data.id;
        this.title = data.title;
    }
}